export class PaymentReminderPost {

    constructor(
        public bookingId: number,
        public emails: string[],
        public withPastePixel: boolean,
        public templateId: number
    ){}
}
